module.exports = __webpack_public_path__ + "img/england-logo-icon.3d1116a6.png";